let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lvyQN")).then(() => parcelRequire('lFs8E'));